// Helper functions for filtering
export const defaultMatcher = (node, nodeID, fname) => {
  if (fname === null) {
    return node.nodeId === nodeID;
  }
  return node.nodeId === nodeID && node.fname === fname;
};

export const findTreeNode = (node, filter, fname, matcher = defaultMatcher) => {
  if (matcher(node, filter, fname)) {
    return { ...node };
  }
  if (!node.children && (!node.length || node.length === 0)) {
    return false;
  }

  const nodeArray = node.children ? node.children : node;
  for (let i = 0; i < nodeArray.length; i += 1) {
    const searchedNode = findTreeNode(nodeArray[i], filter, fname, matcher);
    if (searchedNode) {
      return searchedNode;
    }
  }
  return false;
};

export const updateTreeNode = (
  node,
  updatedProps,
  filter,
  fname,
  matcher = defaultMatcher,
) => {
  if (matcher(node, filter, fname)) {
    return true;
  }
  if (!node.children && (!node.length || node.length === 0)) {
    return false;
  }

  const nodeArray = node.children ? node.children : node;
  for (let i = 0; i < nodeArray.length; i += 1) {
    const searchedNode = updateTreeNode(
      nodeArray[i],
      updatedProps,
      filter,
      fname,
      matcher,
    );
    if (searchedNode) {
      if (searchedNode === true) {
        nodeArray[i] = {
          ...nodeArray[i],
          ...updatedProps,
          objectType: 'operand',
        };
      }
      return nodeArray;
    }
  }
  return false;
};

export const getDeepTreeCopy = dataTree => {
  const treeString = JSON.stringify(dataTree);
  return JSON.parse(treeString);
};
